import { getBounds } from 'geolib';
import { Polygon } from 'maptalks';

type LatLon = Parameters<typeof getBounds>[0];

/**
 * Builds a maptalks rectangular Polygon spanning the bounding box of the given
 * coordinates. Shared by the GCP map and the uploader cluster map so both fit
 * their view to the same bounds geometry.
 */
export const getBoundsPolygon = (coords: LatLon): Polygon => {
  const { minLat, maxLat, minLng, maxLng } = getBounds(coords);
  return new Polygon([
    [minLng, minLat],
    [minLng, maxLat],
    [maxLng, maxLat],
    [maxLng, minLat],
  ]);
};
